import React from "react";

const Checkbox = ({ pid, label, isSelected, onCheckboxChange, hasRewards }) => (
  <div className={"form-check hasRewards--" + hasRewards}>
    <label>
      <input
        type="checkbox"
        label={label}
        data-pid={pid}
        checked={isSelected}
        onChange={onCheckboxChange}
        className="form-check-input"
      />
      {label}
    </label>
  </div>
);

export default Checkbox;
